import { useEffect, useState } from 'react';
import { API_BASE } from '../../../config/config';

export function useOperatorUnits(operatorName) {
  const [units, setUnits] = useState([]);

  useEffect(() => {
    if (!operatorName) {
      setUnits([]);
      return;
    }

    const ac = new AbortController();

    (async () => {
      try {
        const res = await fetch(
          `${API_BASE}/api/units?operator=${encodeURIComponent(operatorName)}`,
          { signal: ac.signal }
        );
        const data = await res.json();
        const mapped = Array.isArray(data)
          ? data
              .filter((u) => u.Description === operatorName)
              .map((u) => ({ id: String(u.Name), name: String(u.Name) }))
          : [];
        setUnits(mapped);
      } catch {
        setUnits([]);
      }
    })();

    return () => ac.abort();
  }, [operatorName]);

  return { units };
}
